module.exports = __webpack_public_path__ + "img/startup-thumb.3d41be35.png";